import React from 'react'
import { Select } from 'antd'
import { ProfileOutlined } from '@ant-design/icons'
import { useSelector, useDispatch } from 'react-redux'

import { getCompanyById } from '../../../../utils'
import { set_setting } from '../../../../redux/slice/settings'

const Company = () => {
  const dispatch = useDispatch()
  const handleChange = value => {
    dispatch(
      set_setting({
        setting: 'company',
        value,
      }),
    )
    window.location.reload()
  }

  const companies = useSelector(s => s._auth.business_accounts)
  const selected = localStorage.getItem('app.settings.company')
  const selectedCompany = getCompanyById(companies, selected)
  const singleCompany = companies.length === 1

  const select = (
    <Select defaultValue={parseInt(selected, 10)} value={parseInt(selected, 10)} style={{ width: 160 }} disabled={companies.length === 0} onChange={handleChange} className="ml-2">
      {companies.map(c => {
        return (
          <Select.Option key={c.id} value={c.id} company={c} selected={selectedCompany && selectedCompany.id === c.id ? 'true' : 'false'}>
            {c.name}
          </Select.Option>
        )
      })}
    </Select>
  )

  const text = <span className="ml-2">{selectedCompany ? selectedCompany.name : '...'}</span>

  return (
    companies.length > 0 && (
      <>
        <ProfileOutlined style={{ fontSize: 16 }} />
        <span style={{ marginLeft: '3px' }}>
          {singleCompany && text}
          {!singleCompany && select}
        </span>
      </>
    )
  )
}

export default Company
